import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { PitchTitleIcon } from 'sections/Benefits/svg';
import { supportBenefitsCards } from 'sections/Benefits/Support/data';
import useWindowSize from 'utils/hooks/useWindowSize';
import Card from 'components/Card';
import styles from 'sections/Benefits/Support/components/SectionSupportBenefitsCards/SectionSupportBenefitsCards.module.scss';

const cn = classNames.bind(styles);

const SectionSupportBenefitsCards = (): ReactElement => {
  const { width: screenWidth } = useWindowSize(); 

  const supportBenefitsCardsList = supportBenefitsCards.map((card) => {
    return (
      <Card className={cn('benefits-card')} key={card.icon}>
        <div className={cn('benefits-card__content')}>
          <Card.Header className={cn('benefits-card__title-box')}>
            <div className={cn('benefits-card__icon')}>
              <img src={`/images/pages/Benefits/Support/${card.icon}`} alt={card.alt} />
            </div>
            <h3 className={cn('benefits-card__title')}>{card.title}</h3>
          </Card.Header>  
          <Card.Content className={cn('benefits-card__description')}>
            <p>{card.description}</p>
          </Card.Content>
        </div>
      </Card>
    );
  });

  return (
    <section className={cn('benefits-cards')} id="benefits-cards">
      <div className={cn('container')}>
        <div className={cn('benefits-cards__title-box')}>
          {PitchTitleIcon}
          {screenWidth >= 576
            ?
            <h2 className={cn('benefits-cards__title')}>
              <span>What DFA Support Brings</span> 
              <span>to Your Business</span>
            </h2>
            :
            <h2 className={cn('benefits-cards__title')}>
              What DFA Support Brings to Your Business
            </h2>
          }
          {screenWidth >= 576
            ?
            <p className={cn('benefits-cards__title-description')}>
              <span>Discover how our networking benefits can elevate your</span> 
              <span>freight forwarding operations.</span>
            </p>
            :
            <p className={cn('benefits-cards__title-description')}>
              Discover how our networking benefits can elevate your freight forwarding operations. 
            </p>
          }
        </div>
          <ul className={cn('benefits-cards__list')}>
            {supportBenefitsCardsList}
        </ul>
      </div>
    </section>
  );
};

export default SectionSupportBenefitsCards;